import {
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  output,
  inject,
  input,
} from '@angular/core';

import {
  ConnectedOverlayDirective,
  OverlayOriginDirective,
  IconComponent,
  RtTooltip,
  ButtonComponent,
} from '@core/user-interface-legacy';

import type { InsertPlaceholderInputDirective } from '../insert-placeholder-input.directive';
import type { Placeholder } from '../placeholder';
import { PlaceholderSelectDropdownComponent } from '../placeholder-select-dropdown/placeholder-select-dropdown.component';
import { PlaceholderService } from '../placeholder.service';

@Component({
  selector: 'rt-placeholder-category-button',
  templateUrl: './placeholder-category-button.component.html',
  styleUrls: ['./placeholder-category-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    OverlayOriginDirective,
    RtTooltip,
    IconComponent,
    ConnectedOverlayDirective,
    PlaceholderSelectDropdownComponent,
  ],
})
export class PlaceholderCategoryButtonComponent {
  private readonly placeholderService = inject(PlaceholderService);

  public readonly category = input<string>(undefined!);
  public readonly activeTarget = input<InsertPlaceholderInputDirective>();
  public readonly placeholders = input<Placeholder[]>(undefined!);
  public placeholderCategoryTranslationMap =
    this.placeholderService.placeholderCategoryTranslationMap;

  @ViewChild('placeholderSelectDropdown')
  public placeholderSelectDropdown: ConnectedOverlayDirective;

  public select = output<Placeholder>();

  public placeholderSelectDropdownToggle(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.placeholderSelectDropdown.open = !this.placeholderSelectDropdown.open;
  }
}
